import { BCMSRecord, DisabledPrompt, StateManager, useBCMSContext, useModel, useWorkflow } from "@bcm-dev/bcms-vite";
import { CustomModalContent } from "components/custom-ui/CustomModal";
import InfoAlertView from "components/shared/views/InfoAlertView";
import { PrimaryButton, SecondaryButton } from "components/ui";
import AddUnlinkedTransferAccountForm from "components/workflows/AddUnlinkedTransferAccountWorkflow/classes/AddUnlinkedTransferAccountForm";
import AddUnlinkedTransferAccountFormUI from "components/workflows/AddUnlinkedTransferAccountWorkflow/classes/AddUnlinkedTransferAccountFormUI";
import Classes from "model";
import { SVGAsset } from "res";
import "./styles.css";

export default function AddUnlinkedTransferAccountChoiceView(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);

  const data = { ...getDefaultData(context), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
      data: state.data,
      ui: state.ui,
      
  });

  return (
    <StateManager state={ { data, ui } } controller={ controller }>
      <Content/>
    </StateManager>
  )
}

function Content(props) {
  const { nextStep } = useWorkflow() ?? {};
  const { branding, settings } = useModel();
  const{ options } = branding;
  const showMyAccountAtAnotherFIButton = options.anotherfiaccount_abi22 === "true";
  const showSomeoneElsesAccountButton = options.someoneelseacct_abi22 === "true";
  const onSomeoneElseClick = () => nextStep();

  return (
    <CustomModalContent className="flex-container flex-horizontal align-top">
      <div className="add-unlinked-transfer-account-choice-view">
        <div className="flex-container flex-vertical header-container">
          <div className="flex-container flex-horizontal">
            <b className="set-width">Add:</b>
            <p className="flex-width"></p>
          </div>
          
          { showMyAccountAtAnotherFIButton &&
          <DisabledPrompt>
            <PrimaryButton text="My Account At Another Financial Institution"/>
          </DisabledPrompt>
          }
          { showSomeoneElsesAccountButton && <SecondaryButton text={ `Someone Else's Account At ${ settings.fiName }` } dataPoint="Add_Unlinked_Transfer_Account_Modal_Someone_Elses_Account_Button" onClick={ onSomeoneElseClick } /> }
          <InfoAlertView className="set-width" text="Accounts added here are for transferring funds only." icon={ <SVGAsset id="InfoIcon" /> }/>
        </div>
      </div>
    </CustomModalContent>
  )
}

export const getDefaultData = () => {

}

export const getDefaultUI = () => {
  const form = AddUnlinkedTransferAccountForm.init({});

  return {
    formUI: AddUnlinkedTransferAccountFormUI.init(form)
  }
}
